import { render } from "./EmployeeTrackers.vue?vue&type=template&id=01b38730"
import script from "./EmployeeTrackers.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__